import * as React from 'react';
import { connect } from 'react-redux';
import { actionCreators } from "../../../store/integration/JiraStore";
import { ApplicationState } from "../../../store/index";
import { IConnectionsState } from "../../../store/integration/common";
import JiraConnectionEdit from './JiraConnectionEdit';
import { SourceType } from '../../../store/ExternalEpmConnectStore';
import BasicAuthConnectionsList from '../BasicAuthConnectionsList';
import { IConnectionInfo } from '../../../entities/Metadata';

type OwnProps = {
    connectionId?: string;
    disabled?: boolean;
    onSelect: (connection: IConnectionInfo) => void;
};

type StateProps = { connections: IConnectionsState };
type Props = StateProps & typeof actionCreators & OwnProps;

const JiraConnectionsList = (props: Props) => {
    React.useEffect(() => {
        props.loadConnections();
    }, []);
    return <BasicAuthConnectionsList
        disabled={props.connections.isLoading || !!props.disabled}
        sourceType={SourceType.Jira}
        connections={props.connections.data}
        onConnectionSelect={props.onSelect}
        onConnectionRemove={props.removeConnection}
        onConnectionRename={props.renameConnection}
        renderAdd={(onCreated: (connectionId: string) => void, onDismiss: () => void) =>
            <JiraConnectionEdit onCreated={onCreated} onDismiss={onDismiss} />}
        renderEdit={(connectionId: string, onDismiss: () => void) =>
            <JiraConnectionEdit connectionId={connectionId} onDismiss={onDismiss} />}
    />;
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return { connections: state.jira.connections };
}

export default connect(mapStateToProps, actionCreators)(JiraConnectionsList);
